import { render, staticRenderFns } from "./addUserFace.vue?vue&type=template&id=0a4e2fec&scoped=true"
import script from "./addUserFace.vue?vue&type=script&lang=js"
export * from "./addUserFace.vue?vue&type=script&lang=js"
import style0 from "./addUserFace.vue?vue&type=style&index=0&id=0a4e2fec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4e2fec",
  null
  
)

export default component.exports